import { observer } from 'mobx-react-lite'
import { type NumericQuestionAnswerEditorViewModel } from '@/features/jobs/questions/numeric/NumericQuestionAnswerEditorViewModel'
import { NumericQuestionAnswerEditor } from './index'

export interface NumericQuestionAnswerEditorContainerProps {
  questionId: string
  editorVm: NumericQuestionAnswerEditorViewModel
  isDisabled?: boolean
  'aria-describedby'?: string
  'aria-labelledby'?: string
}

export const NumericQuestionAnswerEditorContainer = observer(
  function NumericQuestionAnswerEditorContainer({
    editorVm,
    questionId,
    isDisabled,
    ...rest
  }: NumericQuestionAnswerEditorContainerProps) {
    const precision =
      editorVm.format.type === 'Decimal' ? editorVm.format.places : 0

    return (
      <NumericQuestionAnswerEditor
        value={editorVm.value}
        onChange={editorVm.respond}
        precision={precision}
        isDisabled={isDisabled}
        commit$={editorVm.flush$}
        testId={`numeric-question-answer-editor-${questionId}`}
        {...rest}
      />
    )
  },
)
